import {useQuery} from "react-query";
import userService from "../../services/UserService";
import {UserSearchRequest} from "../../models/user";

export default function useUsers(request?: UserSearchRequest) {
   return useQuery(['users', request], () => userService.search(request));
}